import React, { useState, useEffect, useRef } from "react";

import DropDown from "../elements/dropDown";
import DynamicTextarea from "../elements/DynamicTextarea";
import NoInputCalendar from "../DatePicker/noinputdatepicker";
import "./mapedokumentacijaitem.css";
import "./flowSymbols.css";
import LinkPopup from "../LinkPopup";
import FlowSymbol, { SYMBOL_TYPES, normalizeSymbolType } from "../flowSymbol";
import {
  getSafeDocumentHref,
  hasDocumentContent,
} from "../../utils/documentLinks";
import {
  ACCEPTED_EXTENSIONS,
  downloadActivityDocument,
} from "../../utils/activityDocuments";

const PICKABLE_SYMBOL_TYPES = SYMBOL_TYPES.filter((s) => s.value);

export default function MapeDokumentacijaItem({
  designations,
  dueDate,
  responsibles,
  editing,
  links,
  handleRejectMapaDukument,
  handleSetEditProcedureRow,
  handleUpdateProcedureRow,
  row,
  handleChangeProcedureRow,
  handleSelectProceduraRowResponsibles,
  handleChangeProcedureRowDueDate,
  handleChangeNewMapaDocument,
  handleAddNewMapaDocumentList,
  handleAddMapaDocumentName,
  handleRemoveMapaDocument,
  handleUploadMapaDocument,
  setActivityToDelete,
  mapa,
  list,
  validationsErrors,
  stepNumber,
  isLastStep,
  canEdit = true,
}) {
  const [openLinkPopup, setOpenLinkPopup] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChosen = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file || !handleUploadMapaDocument) return;
    setUploading(true);
    try {
      await handleUploadMapaDocument(false, row, file);
    } finally {
      setUploading(false);
    }
  };
  const rowDocuments = row.activities_documents || [];

  const handleAddDocumentName = () => {
    const name = documentName.trim();
    if (!name) return;
    handleAddMapaDocumentName(false, row, name);
    setDocumentName("");
  };

  const taRef1 = useRef();
  const taRef2 = useRef();

  useEffect(() => {
    if (taRef1.current && taRef2.current) {
      const scrollHeight1 = taRef1.current.scrollHeight;

      const height2 = +taRef2.current.style.height.split("p")[0];

      if (scrollHeight1 > height2) {
        taRef2.current.style.height = `${scrollHeight1}px`;
      }
      taRef1.current.style.height = `${scrollHeight1}px`;
      const scrollHeight2 = taRef2.current.scrollHeight;

      const height1 = +taRef1.current.style.height.split("p")[0];

      if (scrollHeight2 > height1) {
        taRef1.current.style.height = `${scrollHeight2}px`;
      }
      taRef2.current.style.height = `${scrollHeight2}px`;
    }
  }, [row]);

  const diagramText =
    row?.name?.trim?.() ||
    row?.activity_name?.trim?.() ||
    row?.title?.trim?.() ||
    row?.diagram_text?.trim?.() ||
    row?.description?.trim?.() ||
    "";

  return (
    <>
    <ul
      className={`poslovni-procesi-table-list${editing ? " editing" : ""}`}
    >
      <li
        className="poslovni-procesi-table-item"
        style={{ justifyContent: "center" }}
      >
        <div className="flow-step-order">{stepNumber || ""}</div>
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{
          alignItems: "flex-start",
          height: "auto",
          flexDirection: "column",
        }}
      >
        <FlowSymbol
          type={row.symbol_type}
          text={diagramText}
          showConnector={!isLastStep && !editing}
        />
        {editing && (
          <div style={{ width: "100%", marginTop: "6px" }}>
            <select
              className="flow-symbol-select"
              value={normalizeSymbolType(row.symbol_type)}
              onChange={(e) => {
                handleChangeProcedureRow(e, "symbol_type", row);
              }}
            >
              <option value="">Izaberite simbol</option>
              {PICKABLE_SYMBOL_TYPES.map((st) => (
                <option key={st.value} value={st.value}>
                  {st.label}
                </option>
              ))}
            </select>
          </div>
        )}
        {row.editing && validationsErrors && validationsErrors["symbol_type"] && (
          <div className="input-error-message">Obavezno polje</div>
        )}
        {editing && (
          <textarea
            className="dynamic-textarea-auto"
            ref={taRef1}
            rows="1"
            onChange={(e) => {
              handleChangeProcedureRow(e, "name", row);
            }}
            value={row.name ? row.name : ""}
            readOnly={!editing}
          />
        )}
        {row.editing && validationsErrors && validationsErrors["name"] && (
          <div className="input-error-message">Obavezno polje</div>
        )}
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{
          alignItems: "flex-start",
        }}
      >
        <textarea
          className="dynamic-textarea-auto"
          ref={taRef2}
          rows="1"
          onChange={(e) => {
            handleChangeProcedureRow(e, "description", row);
          }}
          value={row.description}
          readOnly={!editing}
        />
        {row.editing &&
          validationsErrors &&
          validationsErrors["description"] && (
            <div className="input-error-message">Obavezno polje</div>
          )}
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{ display: "flex", alignItems: "flex-start" }}
      >
        <div
          style={{
            width: "55%",
            borderRight: "1px solid var(--mainColor)",
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            paddingTop: "2px",
          }}
        >
          <DropDown
            isMulti={true}
            list={designations}
            onChange={handleSelectProceduraRowResponsibles(row)}
            selectedValues={responsibles}
            fontSize={12}
            paddingLeft={0}
            flexDirection="column"
            whiteSpace="wrap !important"
            valuePadding="0"
            disabled={!editing}
            control={{ alignItems: "flex-start" }}
          />
          {row.editing &&
            validationsErrors &&
            validationsErrors["activities_designations"] && (
              <div className="input-error-message">Obavezno polje</div>
            )}
        </div>
        <div
          style={{
            width: "45%",
            position: "relative",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <textarea
            className="dynamic-textarea-auto"
            rows="1"
            onChange={(e) => {
              handleChangeProcedureRow(e, "due_date", row);
            }}
            value={row.due_date}
            readOnly={!editing}
          />
        </div>
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{
          position: "relative",
          alignItems: "flex-start",
        }}
      >
        <ul
          style={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {(links || []).filter(hasDocumentContent).map((link) => {
            const href = getSafeDocumentHref(link.path);
            const label = String(link.name || "").trim() || link.path;
            return (
              <div className="document-entry" key={link.id}>
                {link.is_file ? (
                  <button
                    type="button"
                    className="document-file-button"
                    title="Preuzmite fajl"
                    onClick={() => downloadActivityDocument(link)}
                  >
                    {label}
                  </button>
                ) : href ? (
                  <a
                    className="document-path-link"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {label}
                  </a>
                ) : (
                  <span className="document-path-text">{label}</span>
                )}
                {editing && (
                  <button
                    type="button"
                    className="document-remove-button"
                    title="Uklonite dokument"
                    onClick={() =>
                      handleRemoveMapaDocument(false, row, link.id)
                    }
                  >
                    ×
                  </button>
                )}
              </div>
            );
          })}
          {editing && (
            <div className="document-name-input-wrapper">
              <input
                className="document-name-input"
                maxLength={255}
                placeholder="Naziv dokumenta"
                value={documentName}
                onChange={(e) => setDocumentName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddDocumentName();
                  }
                }}
              />
              <button
                type="button"
                className="document-name-add-button"
                title="Dodajte naziv dokumenta"
                disabled={!documentName.trim()}
                onClick={handleAddDocumentName}
              >
                +
              </button>
            </div>
          )}
        </ul>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "12px",
            paddingRight: "5px",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            className="document-file-input"
            accept={ACCEPTED_EXTENSIONS}
            onChange={handleFileChosen}
          />
          <button
            type="button"
            disabled={!editing || uploading}
            className="mapedokumentacijaitem-button"
            title="Otpremite fajl sa računara"
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
          >
            <img alt="" src="/images/doc.png" />
          </button>
          <button
            type="button"
            disabled={!editing || uploading}
            className="mapedokumentacijaitem-button"
            onClick={() => {
              setOpenLinkPopup((state) => !state);
              handleAddNewMapaDocumentList(false, row);
            }}
          >
            <img alt="" src="/images/link.png" />
          </button>
        </div>
      </li>
      <li className="poslovni-procesi-table-item">
        {/* Akcije izmene i brisanja samo za rolu koja sme da menja mapu */}
        {canEdit && (
        <div className="new-procedure-options-block">
          <button
            type="button"
            className="employee-item-options-button"
            onClick={() => {
              if (editing) {
                handleUpdateProcedureRow(row);
              } else {
                if (
                  !list.some((el) => el.editing) &&
                  !mapa.activities.some((el) => el.editing)
                ) {
                  handleSetEditProcedureRow(row);
                }
              }
            }}
          >
            <img
              src={editing ? "/images/check.png" : "/images/edit.png"}
              alt="im"
            />
          </button>
          <button
            type="button"
            className="employee-item-options-button"
            onClick={() => {
              setActivityToDelete(row);
            }}
          >
            <img src="/images/trash.png" />
          </button>
        </div>
        )}
      </li>
    </ul>
    {openLinkPopup && (
      <>
        <div className="loading"></div>
        <LinkPopup
          //  handleAddLink={handleAddLink}
          setOpenLinkPopup={setOpenLinkPopup}
          handleChangeNewMapaDocument={handleChangeNewMapaDocument}
          link={rowDocuments[rowDocuments.length - 1]}
          row={row}
          isNewRow={false}
          handleSaveNewMapaDocument={() => {}}
          handleRejectMapaDukument={handleRejectMapaDukument}
        />
      </>
    )}
    </>
  );
}




